import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import achievementsReducer from "./achievementsReducer";
import AddressReducer from "./AddressReducer";
import AdminReducer from "./adminReducer";
import affiliateReducer from "./affiliateReducer";
import competitionReducer from "./competitionReduder";
import dashboardReducer from "./dashboardReducer";
import ipdReducer from "./ipd";
import loggedReducer from "./isLogged";
import loaderReducer from "./loader";
import notificationReducer from "./notifications";
import paymentReducer from "./paymentReducer";
import payoutReducer from "./payoutReducer";
import sidebarMReducer from "./sidebarMReducer";
import { SidebarMain, SidebarSub } from "./sidebarReducer";
import SupportCasesReducer from "./SupportReducer";
import themeReducer from "./themeReducer";
import {
  RefftokenReducer,
  tokenExpiryReducer,
  tokenReducer,
} from "./tokenReducer";
import TrademateReducer from "./trademateReducer";
import TraderListReducer from "./TraderListReducer";
import userProfileReducer from "./userProfileReducer";
import candlestickReducer from "./candleStickReducer";
import navigationReducer from "./navigateReducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "isLogged",
    "ipd",
    "SidebarM",
    "SidebarS",
    "ACCtoken",
    "expiresIn",
    "REFFtoken",
    "dashboard",
    "payments",
    "user",
    "selectAdress",
    "accountCreate",
    "traderlist",
    "supportcases",
    "isAdmin",
    "trademate",
    "affiliate",
    "notificationReducer",
    "achievementsReducer",
    "payoutReducer",
    "themeReducer",
    "navigationReducer",
  ],
};

const rootReducer = combineReducers({
  isLogged: loggedReducer,
  ipd: ipdReducer,
  sidebarM: SidebarMain,
  sidebarS: SidebarSub,
  ACCtoken: tokenReducer,
  REFFtoken: RefftokenReducer,
  expiresIn: tokenExpiryReducer,
  dashboard: dashboardReducer,
  payments: paymentReducer,
  sidebar: sidebarMReducer,
  user: userProfileReducer,
  selectAdress: AddressReducer,
  accountCreate: competitionReducer,
  traderlist: TraderListReducer,
  supportcases: SupportCasesReducer,
  isAdmin: AdminReducer,
  trademate: TrademateReducer,
  affiliate: affiliateReducer,
  notifications: notificationReducer,
  achievements: achievementsReducer,
  payout: payoutReducer,
  theme: themeReducer,
  loader: loaderReducer,
  candlestickChart: candlestickReducer,
  navigation: navigationReducer,
});

export default persistReducer(persistConfig, rootReducer);
